export default {
    baseStyle: (props) => ({
        drawerContent: {
            maxWidth: '483px',
            padding: { base: 0 }
        },
        drawerBody: {
            padding: { base: '75px 16px 36px', lg: '96px 32px 32px' }
        },
        drawerWrapper: {
            // These two needs to be converted as the ones below after we will have the CMS config for them
            '& .er-modal-code-title': {
                fontSize: { base: 'md' },
                lineHeight: { lg: '20px' },
                fontWeight: { base: 'bold' },
                textTransform: { base: 'uppercase' },
                textAlign: { base: 'center' },
                marginBottom: { base: 1 }
            },
            '& .er-modal-code': {
                width: { base: 'fit-content' },
                margin: { base: '0 auto' },
                fontSize: { base: 'xl', lg: '2xl' },
                lineHeight: { lg: '30px' },
                fontWeight: { base: 'bold' },
                textTransform: { base: 'uppercase' },
                textAlign: { base: 'center' },
                padding: { base: '16px 24px' },
                border: { base: '1px solid black' },
                marginBottom: { base: 4 }
            }
        },
        erModalIcon: {
            width: { base: '40px' },
            height: { base: '40px' },
            margin: { base: '0 auto' },
            marginBottom: { base: 4 }
        },
        erModalTitle: {
            fontSize: { base: 'xl', lg: '32px' },
            lineHeight: { base: '100%', lg: '100%' },
            fontWeight: { base: 'bold' },
            textTransform: { base: 'uppercase' },
            textAlign: { base: 'center' },
            paddingBottom: { base: 4, lg: 6 }
        },
        erModalSubtitle: {
            fontSize: { base: 'sm', lg: 'md' },
            lineHeight: { base: '18px', lg: '24px' },
            paddingBottom: { base: 4, lg: 6 }
        },
        erModalNote: {
            fontSize: { base: 'xs' },
            lineHeight: { base: '15px' },
            color: { base: 'grey.700' }
        },
        closeButton: {
            position: { base: 'absolute' },
            top: { base: '10px', lg: '16px' },
            right: { base: '16px' },
            width: { base: '24px' },
            height: { base: '24px' },
            minW: { base: 'auto' }
        }
    })
}
